import { writable } from 'svelte/store';
import { resetEditStore } from './editStore';
import { resetImageStore } from './imageStore';

const defaultSession = { 
  loggedIn: false, 
  userId: null, 
  name: '', 
  email: '', 
  isGuest: false, 
  sessionId: null,
  rionBalance: 0 
};

function loadInitial() {
  if (typeof localStorage === 'undefined') return defaultSession;
  const stored = localStorage.getItem('erion_session');
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      if (parsed) {
        return { ...defaultSession, ...parsed };
      }
    } catch (e) {
      console.error('failed to parse session', e);
    }
  }
  return defaultSession;
}

export const sessionStore = writable(loadInitial());

if (typeof localStorage !== 'undefined') {
  sessionStore.subscribe((value) => {
    localStorage.setItem('erion_session', JSON.stringify(value));
  });
}

export function login({ userId, name, email, photoURL = '', isGuest = false, rionBalance = 0 }) {
  sessionStore.update(prev => ({
    loggedIn: true,
    userId,
    name,
    email,
    photoURL,
    isGuest,
    rionBalance,
    // 이전 세션 ID가 있으면 재사용하여 작업이 사라지지 않도록 함
    sessionId: prev.sessionId || generateSessionId()
  }));
}

export function updateRionBalance(balance) {
  sessionStore.update(prev => ({
    ...prev,
    rionBalance: balance
  }));
}

function generateSessionId() {
  if (typeof crypto !== 'undefined') {
    if (typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    if (typeof crypto.getRandomValues === 'function') {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    }
  }
  return 'session-' + Math.random().toString(16).slice(2) + Date.now().toString(16);
}

export function logout() {
  // 로그아웃 시 새 세션 ID를 발급하여 다음 사용자와 세션 ID가 겹치지 않도록 한다
  sessionStore.update(() => ({
    ...defaultSession,
    sessionId: generateSessionId()
  }));
  
  // 편집 및 이미지 스토어 리셋
  resetEditStore();
  resetImageStore();
}